import update from 'immutability-helper';
import get from 'lodash/get';
import { formatRelateLocationsToAddressResponse } from 'locations/reducers';
import {
  GET_DELIVERABLE_LOCATIONS_REQUEST,
  GET_DELIVERABLE_LOCATIONS_SUCCESS,
  GET_DELIVERABLE_LOCATIONS_FAILURE
} from 'locations/constants/actionTypes';

export const locationsDeliverableInitialState = {
  isSettingAddress: false,
  error: []
};
const locationsDeliverable = (
  state = locationsDeliverableInitialState,
  action
) => {
  switch (action.type) {
    case GET_DELIVERABLE_LOCATIONS_REQUEST: {
      return {
        ...state,
        isSettingAddress: true,
        error: []
      };
    }
    case GET_DELIVERABLE_LOCATIONS_SUCCESS: {
      let updateObj = formatRelateLocationsToAddressResponse(
        action.payload.locations
      );

      updateObj = {
        $merge: locationsDeliverableInitialState,
        ...updateObj
      };

      return update(state, updateObj);
    }
    case GET_DELIVERABLE_LOCATIONS_FAILURE: {
      return {
        ...state,
        isSettingAddress: false,
        error: [get(action, ['payload', 'message'])]
      };
    }
    default:
      return state;
  }
};

export default locationsDeliverable;
